export default __webpack_public_path__ + "static/media/tokens.01297ec6.png";